export const MAX_SIZE_UPLOAD = 10 * (10 ** 6);
